import styled from "styled-components";
import { useRecoilState } from "recoil";
import { accountName, bookmarkList, toastMessage } from "../../store";
import { flexCenterDir } from "../../style/theme";
import { useEffect, useState } from "react";
import axios from "axios";

import Pagination from "./Pagination";
import IssuesList from "./IssuesList";

const Issues = () => {
	const [account, setAccount] = useRecoilState(accountName);
	const [bookmark, setBookmark] = useRecoilState(bookmarkList);
	const [message, setMessage] = useRecoilState(toastMessage);

	const [issue, setIssue] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [posts] = useState(10);

	useEffect(() => {
		let temp: any = [];

		if (bookmark) {
			const getIssues = async () => {
				await Promise.all(
					bookmark.map(async (name: string) => {
						let url = `https://api.github.com/repos/${account}/${name}/issues`;

						await axios
							.get(url, {
								headers: {
									Accept: "application/vnd.github.nightshade-preview+json",
								},
							})
							.then((res) =>
								res.data.forEach((el: any) => {
									el.repo = name;
									temp.push(el);
								})
							)
							.catch((err) => setMessage("Issue를 찾다가 에러가 발생했습니다"));
					})
				);

				setIssue(temp);
			};

			getIssues();
		}
	}, [account, bookmark]);

	const lastPost = currentPage * posts;
	const firstPost = lastPost - posts;
	const currentPosts = issue.slice(firstPost, lastPost);
	const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

	return (
		<IssuesSection>
			<IssuesList currentPosts={currentPosts}></IssuesList>

			<Pagination
				posts={posts}
				totalPosts={issue.length}
				paginate={paginate}
				currentPage={currentPage}
			/>
		</IssuesSection>
	);
};

const IssuesSection = styled.section`
	${flexCenterDir}

	padding-top: 10rem;
`;

export default Issues;
